import { useCallback, useState } from 'react';

import * as XLSX from 'xlsx';

export function useExcelParser() {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const parseFile = useCallback(async file => {
    return new Promise((resolve, reject) => {
      if (!(file instanceof Blob)) return resolve([]);

      const reader = new FileReader();

      reader.onload = e => {
        try {
          const result = e.target?.result;
          if (!result) throw new Error('Failed to read file');

          const buffer = new Uint8Array(result);
          const workbook = XLSX.read(buffer, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          const csv = XLSX.utils.sheet_to_csv(worksheet, { strip: true });

          setData(jsonData);
          resolve({ json: jsonData, csv });
        } catch (err) {
          reject(err);
        }
      };

      reader.onerror = () => reject('Error reading file');
      reader.readAsArrayBuffer(file);
    });
  }, []);

  return { data, error, loading, parseFile };
}
